import React, { useEffect, useState } from 'react';
import IntlMessages from '@projectK/helpers/IntlMessages';

import * as yup from 'yup';
import { useInfoViewActionsContext } from '@projectK/context/InfoViewContextProvider';
import jwtAxios from '@projectK/services/auth/JWT';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import CompanyTheme from '@projectK/constants/CompanyTheme';
import { useApplicationSettings } from '@projectK/context/VerbiageContextProvider';
import { useToast } from '@projectK/context/ToastProvider';
import { AddParentMemberModalMain } from '@projectK/MainComponents';
import PropTypes from 'prop-types';
const validationSchema = yup.object({
  first_name: yup
    .string()
    .matches(/^\S(?:.*\S)?$/, () => <IntlMessages id='validation.firstName.noSpaces' />)
    .required(<IntlMessages id='validation.firstNameRequired' />),
  last_name: yup
    .string()
    .matches(/^\S(?:.*\S)?$/, () => <IntlMessages id='validation.lastName.noSpaces' />)
    .required(<IntlMessages id='validation.lastNameRequired' />),
  role_id: yup
    .string()
    .required(<IntlMessages id='validation.userTypeRequired' />),
  email: yup
    .string()
    .matches(
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
      () => <IntlMessages id='validation.invalidEmailFormat' />
    )
    .typeError(<IntlMessages id='validation.invalidEmail' />)
    .required(<IntlMessages id='validation.emailRequired' />),
});

const customScrollbarStyle = {
  // Define the styles for the scrollbar
  '&::-webkit-scrollbar': {
    width: '8px',
  },

  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#44444461', // Lighter black color
    borderRadius: '8px', // Curved border
  },

  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#666', // Lighter black color on hover
  },
};

const AddParentMembers = ({
  isOpen,
  onClose,
  fetchMembersData,
  mobileMode,
  isMobile,
  formatRoleName,
}) => {
  const { verbiageSettings } = useApplicationSettings();
  const showToast = useToast();
  const companyTheme = CompanyTheme();
  const infoViewActionsContext = useInfoViewActionsContext();
  const [roleOptions, setRoleOptions] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  useEffect(() => {
    fetchInstructorUsersData();
  }, []);
  const { user } = useAuthUser();
  const fetchInstructorUsersData = async () => {
    try {
      const response = await jwtAxios.get(`/roles`);
      const { data } = response;
      setRoleOptions(data.list);
    } catch (error) {
      setRoleOptions([]);
    }
  };

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };
  const handleCloseModalDialog = () => {
    setOpenDialog(false); // to close the dialog
    handleModalClose(); //to close the modal
  };
  const handleModalClose = () => {
    onClose();
  };
  return (
    <AddParentMemberModalMain
      isOpen={isOpen}
      fetchMembersData={fetchMembersData}
      mobileMode={mobileMode}
      isMobile={isMobile}
      customScrollbarStyle={customScrollbarStyle}
      handleDialogOpen={handleDialogOpen}
      validationSchema={validationSchema}
      handleCloseModalDialog={handleCloseModalDialog}
      infoViewActionsContext={infoViewActionsContext}
      verbiageSettings={verbiageSettings}
      companyTheme={companyTheme}
      roleOptions={roleOptions}
      handleCloseDialog={handleCloseDialog}
      onClose={onClose}
      openDialog={openDialog}
      user={user}
      showToast={showToast}
      formatRoleName={formatRoleName}
    />
  );
};

export default AddParentMembers;
AddParentMembers.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  fetchMembersData: PropTypes.func,
  mobileMode: PropTypes.string,
  isMobile: PropTypes.bool,
  formatRoleName: PropTypes.func
};
